module.exports = __webpack_public_path__ + "static/media/PTSerif-Regular.5f7303c0.ttf";